module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#video",
      toString: function () {
        return this.url;
      }
    }